export class LoginModel {
    public username: string;
    public password: string;
    public keepMeSignedIn: boolean;
    public clientId: string;
}
